import { FC } from "react";
import { NonGovernmental } from "types";
import { organizationIcon } from "utils/constant";

type Props = {
  nonGovernmental: NonGovernmental | undefined;
  isOpen: boolean;
  onClose: () => void;
};

const VictimNonGovernmentalDetail: FC<Props> = ({
  nonGovernmental,
  isOpen,
  onClose,
}) => {
  const handleClickOutside = (e: any) => {
    if (e.target.classList.contains("fixed")) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      style={{ marginTop: "0px" }}
      className="fixed inset-0 z-50 flex justify-end bg-black bg-opacity-50 backdrop-blur-sm p-4"
      onClick={handleClickOutside}
    >
      <div className="relative w-full max-w-2xl bg-white p-8 shadow-lg rounded-lg overflow-y-auto">
        <div className="text-base font-semibold text-white bg-[#212121] p-3 inline-block rounded-md">
          Crime Reference &nbsp;&nbsp; : &nbsp;&nbsp;
          {typeof nonGovernmental?.investigation === "object" &&
            nonGovernmental?.investigation?.CR_number}
        </div>

        <br />

        <div className="flex flex-row gap-4 mt-3 items-start">
          <div className="bg-[#BCBCBC66] p-6 rounded-md">
            {organizationIcon}
          </div>
          <div className="flex flex-col w-[250px]">
            {/* <div className="bg-[#9B0505] w-fit px-2 py-[2px] text-white rounded-md text-center font-medium text-sm">
              {governmental?.crime_reference?.crime_reference_number}
            </div> */}
            <h2 className="text-[22px] font-semibold leading-7">
              {nonGovernmental?.organization_name}
            </h2>
          </div>
        </div>

        {[
          {
            property: "Organization Name",
            value: nonGovernmental?.organization_name,
          },
          { property: "Address", value: nonGovernmental?.address },
          {
            property: "Registration Number",
            value: nonGovernmental?.registration_number,
          },
          {
            property: "Non-Governmental Type",
            value: nonGovernmental?.non_governmental_type,
          },
        ]?.map((info, index) => (
          <div
            key={index}
            className="flex flex-row gap-4 mt-3 items-start justify-between border-b border-b-[#E9E9E9] pb-3"
          >
            <p className="font-normal text-base text-[#0A1D39]">
              {info?.property}
            </p>
            <p className="font-normal text-base text-[#0A1D39]">
              {typeof info?.value === "boolean" ||
              typeof info?.value === "object"
                ? info?.value ?? "-"
                : info?.value}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default VictimNonGovernmentalDetail;
